module.exports = __webpack_public_path__ + "img/logo-3.1d0cf63c.svg";